import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useScrollAwareTooltip } from '../../hooks/useScrollAwareTooltip';
import { baseBlack, skyDark } from '../../styles/design-tokens';
import { Checkbox } from '../../ui-library/checkbox/checkbox';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { Text } from '../../ui-library/typography/typography';

type Props = {
  value: string;
  label: string;
  isSelected: boolean;
  isSelectedTrends?: boolean;
  showTrends: boolean;
  selectedCount: number;
  maxSelected?: number;
  description?: string;
  onToggle: (value: string) => void;
  onTrendsToggle?: (value: string) => void;
};

export const FilterItem = ({
  value,
  label,
  description,
  isSelected,
  isSelectedTrends = false,
  showTrends,
  selectedCount,
  maxSelected,
  onToggle,
  onTrendsToggle,
}: Props) => {
  const i18n = useTranslation();
  const canSelectMore = maxSelected ? selectedCount < maxSelected : true;
  const isDisabled = !isSelected && !canSelectMore;
  const forceCloseTooltip = useScrollAwareTooltip();

  const handleToggle = () => {
    onToggle(value);
  };

  const handleTrendsToggle = () => {
    if (isSelected && onTrendsToggle) {
      onTrendsToggle(value);
    }
  };

  return (
    <Group justify="space-between" wrap="nowrap">
      <Group gap="sm" wrap="nowrap" style={{ flex: 1 }}>
        <Tooltip
          label={i18n.t('common.tooltips.max_selection_limit', {
            count: maxSelected,
          })}
          variant="white"
          disabled={!isDisabled || forceCloseTooltip}
        >
          <Checkbox checked={isSelected} disabled={isDisabled} onChange={handleToggle} size="sm" />
        </Tooltip>
        <Tooltip
          label={description}
          variant="white"
          multiline
          maw={300}
          style={{ lineHeight: 1.5 }}
          disabled={!description || forceCloseTooltip}
        >
          <Text
            size="small"
            color={isDisabled ? skyDark : baseBlack}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              flex: 1,
            }}
            onClick={() => {
              if (!isDisabled) {
                handleToggle();
              }
            }}
          >
            {label}
          </Text>
        </Tooltip>
      </Group>

      {showTrends && isSelected && <Checkbox checked={isSelectedTrends} onChange={handleTrendsToggle} size="sm" />}
    </Group>
  );
};
